const CLICK_TYPE_OPTIONS = [
   {
      value: 1,
      label: 'IMPRESSION',
      id: 1,
      name: 'IMPRESSION',
   },
   {
      value: 2,
      label: 'CLICK',
      id: 2,
      name: 'CLICK',
   },
   {
      value: 3,
      label: 'CONVERSION',
      id: 3,
      name: 'CONVERSION',
   },
   {
      value: 4,
      label: 'WEB_SEARCH',
      id: 4,
      name: 'WEB_SEARCH',
   },
   {
      value: 5,
      label: 'EMAIL_SEARCH',
      id: 5,
      name: 'EMAIL_SEARCH',
   },
   {
      value: 6,
      label: 'JOB_FETCH_SEARCH',
      id: 6,
      name: 'JOB_FETCH_SEARCH',
   },
   {
      value: 7,
      label: 'WEB_CLICK',
      id: 7,
      name: 'WEB_CLICK',
   },
   {
      value: 8,
      label: 'JOB_FETCH_CLICK',
      id: 8,
      name: 'JOB_FETCH_CLICK',
   },
   {
      value: 9,
      label: 'DIRECT_EMAIL_SEARCH',
      id: 9,
      name: 'DIRECT_EMAIL_SEARCH',
   },
   {
      value: 10,
      label: 'DIRECT_EMAIL_CLICK',
      id: 10,
      name: 'DIRECT_EMAIL_CLICK',
   },
   {
      value: 11,
      label: 'TIME_EXPIRED',
      id: 11,
      name: 'TIME_EXPIRED',
   },
   {
      value: 12,
      label: 'IP_MISSMATCH',
      id: 12,
      name: 'IP_MISSMATCH',
   },
   {
      value: 13,
      label: 'IP_RATE_OVER',
      id: 13,
      name: 'IP_RATE_OVER',
   },
   {
      value: 14,
      label: 'BOT_CLICK',
      id: 14,
      name: 'BOT_CLICK',
   },
   {
      value: 15,
      label: 'UNAUTHORIZED_API',
      id: 15,
      name: 'UNAUTHORIZED_API',
   },
   {
      value: 16,
      label: 'CID_DISABLED',
      id: 16,
      name: 'CID_DISABLED',
   },
   {
      value: 17,
      label: 'WEB_CONVERSION',
      id: 17,
      name: 'WEB_CONVERSION',
   },
   {
      value: 18,
      label: 'JOB_FETCH_CONVERSION',
      id: 18,
      name: 'JOB_FETCH_CONVERSION',
   },
   {
      value: 19,
      label: 'DIRECT_EMAIL_CONVERSION',
      id: 19,
      name: 'DIRECT_EMAIL_CONVERSION',
   },
   {
      value: 20,
      label: 'JOB_EXPIRED',
      id: 20,
      name: 'JOB_EXPIRED',
   },
   {
      value: 21,
      label: 'ZERO_SEARCH',
      id: 21,
      name: 'ZERO_SEARCH',
   },
   {
      value: 22,
      label: 'HIGH_RISK',
      id: 22,
      name: 'HIGH_RISK',
   },
   {
      value: 23,
      label: 'DIRECT_XML_CLICK',
      id: 23,
      name: 'DIRECT_XML_CLICK',
   },
   {
      value: 24,
      label: 'USER_AGENT_BL_SEARCH',
      id: 24,
      name: 'USER_AGENT_BL_SEARCH',
   },
   {
      value: 25,
      label: 'USER_AGENT_BL_CLICK',
      id: 25,
      name: 'USER_AGENT_BL_CLICK',
   },
   {
      value: 26,
      label: 'IP_ADDRESS_BL_SEARCH',
      id: 26,
      name: 'IP_ADDRESS_BL_SEARCH',
   },
   {
      value: 27,
      label: 'IP_ADDRESS_BL_CLICK',
      id: 27,
      name: 'IP_ADDRESS_BL_CLICK',
   },
   {
      value: 28,
      label: 'JOB_SEARCH_EXTRA',
      id: 28,
      name: 'JOB_SEARCH_EXTRA',
   },
   {
      value: 29,
      label: 'BROKEN_ORDER_RULE',
      id: 29,
      name: 'BROKEN_ORDER_RULE',
   },
   {
      value: 30,
      label: 'BROKEN_ORDER_ALLJOBS',
      id: 30,
      name: 'BROKEN_ORDER_ALLJOBS',
   },
   {
      value: 31,
      label: 'BROKEN_ORDER_BACKUP',
      id: 31,
      name: 'BROKEN_ORDER_BACKUP',
   },
   {
      value: 32,
      label: 'BROKEN_ORDER_FAIL',
      id: 32,
      name: 'BROKEN_ORDER_FAIL',
   },
   {
      value: 33,
      label: 'PREMIUM_WEB_CLICK',
      id: 33,
      name: 'PREMIUM_WEB_CLICK',
   },
   {
      value: 34,
      label: 'JOB_REGISTER',
      id: 34,
      name: 'JOB_REGISTER',
   },
   {
      value: 35,
      label: 'DIRECT_CONVERSION',
      id: 35,
      name: 'DIRECT_CONVERSION',
   },
   {
      value: 36,
      label: 'IP_LOCATION',
      id: 36,
      name: 'IP_LOCATION',
   },
   {
      value: 37,
      label: 'MISSING_LOCATION',
      id: 37,
      name: 'MISSING_LOCATION',
   },
   {
      value: 38,
      label: 'MISSING_JOB',
      id: 38,
      name: 'MISSING_JOB',
   },
   {
      value: 39,
      label: 'INTERNATIONAL_CLICK',
      id: 39,
      name: 'INTERNATIONAL_CLICK',
   },
   {
      value: 40,
      label: 'FIND_BEST_MATCH_JOB',
      id: 40,
      name: 'FIND_BEST_MATCH_JOB',
   },
];

export default CLICK_TYPE_OPTIONS;
